export default {
  1: { name: "ava shop", title: "آوا شاپ" },
  2: { name: "ava box", title: "آوا باکس" },
  3: { name: "ava box", title: "ویژه (VIP)" },
};
